import { useState, useEffect } from "react";
import { accountsService } from "@/services/api/api";
import logger from "../utils/secureLogger";

/**
 * Hook para obtener opciones de proveedores desde la API filtradas por las que existen en DB
 */
export const useProviderOptions = (accounts = []) => {
  const [providerOptions, setProviderOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadProviders = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await accountsService.getCloudProviders();
        const allProviders = response.data || [];
        
        const providersInDB = new Set();
        accounts.forEach(account => {
          if (account.CloudProvider && account.CloudProvider.trim()) {
            providersInDB.add(account.CloudProvider.trim());
          }
        });
        
        const filteredProviders = allProviders
          .filter(cp => providersInDB.has(cp.PublicCloudUid))
          .map(cp => cp.PublicCloudUid)
          .sort();
        
        setProviderOptions(filteredProviders);
        logger.debug('🔍 Available Providers from API:', allProviders.map(cp => cp.PublicCloudUid));
        logger.debug('🔍 Providers in DB:', Array.from(providersInDB));
        logger.debug('🔍 Filtered Providers:', filteredProviders);
      } catch (err) {
        setError(err.message);
        logger.error('Error loading cloud providers:', err);
      } finally {
        setLoading(false);
      }
    };

    if (accounts.length > 0) {
      loadProviders();
    }
  }, [accounts]);

  return { providerOptions, loading, error };
};
